<template>
    <div class="z-0 flex">
        <span class="text-sm capitalize">{{ data.name }}</span>

        <div class="mr-2 ml-auto flex w-8">
            <VehicleType :data="data.type" />
        </div>
        <span class="bg-brand/75 rounded-full px-3 py-0 text-sm text-white capitalize">
            {{ data.registration }}
        </span>
    </div>
</template>

<script setup>
import VehicleType from '../../../table/cellModules/VehicleType.vue';
// import { MuvalButton } from "@buttons";

defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>
